export default {
    LINK: 'LINK',
    IMAGE: 'IMAGE',
};
